<script>
    import { Toaster } from "$lib/components/ui/sonner";
    import * as Tabs from "$lib/components/ui/tabs";
    import * as Tooltip from "$lib/components/ui/tooltip";
    import * as Dialog from "$lib/components/ui/dialog";
    import { Label } from "$lib/components/ui/label";
    import { Input } from "$lib/components/ui/input";
    import { Button, buttonVariants } from "$lib/components/ui/button";
    import { btn, cbtn, dbtn } from '../lib/ldcjs/work/buttons';
    import { getp, postp } from '../lib/ldcjs/getp';
    import Help from './help.svelte';
    import Browse from './browse_f.svelte';
    import Spinner from '../lib/ldcjs/work/spinner.svelte';
    import Table from '../lib/ldcjs/work/table.svelte';
    import Patch from './patch.svelte';
    import InputText from './input_text.svelte';
    import InputSelect from './input_select.svelte';
    import InputCheckbox from './input_checkbox.svelte';
    import UploadFile from './upload.svelte';
    import Releases from '../users/releases.svelte';
    import {
        controller_actions,
        get_kits_for_task,
        get_kits_for_task_all,
        reassign_kits_for_task,
        show_kit,
        create_kits_from_kits_tab
    } from './controllers';
    import { toast } from "svelte-sonner";
    import { response, ok_reload } from './helpers';
    import { create_transcript } from '../lib/ldcjs/waveform/download_transcript_helper';
    import { create_download_tsv, create_download_url } from '../lib/ldcjs/download_helper';
    import { tick } from 'svelte';
    import { refreshToken, getSignedUrlPromise, putObject, s3url, listObjectsV2params, get_json_object, uploadObject, headObject } from '../lib/ldcjs/aws_helper';
    import { fromCognitoIdentity } from "@aws-sdk/credential-provider-cognito-identity";
    import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
    import { TranscribeClient } from "@aws-sdk/client-transcribe";
    import { S3Client, GetObjectCommand, HeadObjectCommand, ListObjectsV2Command, PutObjectCommand } from "@aws-sdk/client-s3";
    import { Upload } from "@aws-sdk/lib-storage";
    import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
    import AudioPlayer from './audio_player.svelte';
    refreshToken({
        fromCognitoIdentity,
        CognitoIdentityClient,
        TranscribeClient,
        S3Client,
        GetObjectCommand,
        HeadObjectCommand,
        ListObjectsV2Command,
        PutObjectCommand,
        Upload,
        getSignedUrl
    });
    let { admin = false, portal_manager = false, project_manager = false } = $props();
    let lead_annotator = $state(project_manager);
    let help = $state(false);
    // let page = 1;
    // function pagef(e){ page = e.detail }
    // let pages = [
    //     [ 'Work',        'all',            "your tasks with links to start" ],
    //     [ 'Projects',    'all',            'projects, tasks, kits' ],
    //     [ 'Browse',      'all',            'browse uploaded files' ],
    //     [ 'Kit Types',   'lead_annotator', 'tasks require a kit type' ],
    //     [ 'Namespaces',  'lead_annotator', 'kit types require a namespace' ],
    //     [ 'Tools',       'lead_annotator', 'kit types require a namespace' ],
    //     [ 'Data Sets',   'lead_annotator', 'tasks can have a data set' ],
    //     [ 'Invites',     'lead_annotator', 'invite people to the site' ],
    //     [ 'Scripts',     'lead_annotator', 'write scripts' ],
    //     [ 'Features',    'admin',          'features for different objects' ],
    //     [ 'Services',    'admin',          'services' ],
    //     [ 'Workflows',   'admin',          'workflows' ],
    //     [ 'Groups',      'admin',          'groups' ],
    //     [ 'Permissions', 'all',            'explore roles and permissions' ]
    // ];
    // let goto_project = $state();
    function goto(x, y){
        if(x.task_id){
            tab = 'projects';
            if(y == 'project') project(x);
            if(y == 'task') task(x);
        }
    }
    function project(e){
        actions.project.get_all();
        all_label = (lead_annotator ? "All" : "My") + " Projects";
        if(e){
            models.project.id = e.project_id;
            models.task.id = null;
            actions.project.get_one('tasks');
        }
    }
    // let goto_task = $state();
    function task(e){
        project(e);
        models.task.id = e.task_id;
        actions.task.get_one('kits');
    }
    // document.getElementById('work1').hidden = true;
    function helpf(e){
        alert(e.detail);
    }
    
    export function browse(x){
        tab = 'browse';
        // browse_a.step1(x);
    }
    let browsex = $state();
    export function uploads(e){
        // page5();
        // browsex.get(e);
    }
    let p = getp(window.location);
    console.log('USERS');
    p.then( (x) => console.log(x) )
    let tab = $state('tasks');
    let tabp = $state(Promise.resolve([]));
    let pp = $state();
    let taskpp = $state();
    let taskuserpp = $state();
    let kitsp = $state();
    let kitspp = $state();
    let donekitsp = $state();
    let style = $state();
    let style_timeout;
    function set_style(e){
        style = `position: absolute; left: ${e.pageX-20}px; top: ${e.pageY+20}px; z-index: 10`;
        if(style_timeout) clearTimeout(style_timeout);
        style_timeout = setTimeout( () => style = null, 2000);
    };
    let member_timeout;
    let memberp = $state(Promise.resolve([]));
    let member_name = $state();
    function memberf(name){
        if(models.task.tab == 'members'){
            return pp.then(x => x.members);
        }
        else if(models.project.tab == 'members'){
            return controller_actions.project_user.not_in(models.project.id, name);
        }
        else if(models.group.tab == 'members'){
            return controller_actions.group_user.not_in(models.group.id, name);
        }
    }
    // use a named function so effect only binds to member_name
    $effect(() => check_member_name(member_name));
    function check_member_name(name){
        if(!name || name.length < 3){
            memberp = Promise.resolve([]);
            return;
        }
        if(typeof(memberf) == 'object'){
            memberp = Promise.resolve(memberf);
            return;
        }
        if(member_timeout) clearTimeout(member_timeout);
        member_timeout = setTimeout(() => memberp = memberf(name), 500);
    }
    function create_name(){
        return { name: document.getElementById('dialog_create_name').value };
    }
    function create_category(){
        return { category: document.getElementById('dialog_create_category').value };
    }
    function member_create(model, x){
        let o = { user_id: x.id };
        if(model == 'task') o.user_id = x.user_id;
        o[model + '_id'] = models[model].id;
        controller_actions[model + '_user'].create(o)
        .then(x => ok_reload(x, () => actions[model].get_one('members')))
        .then(member_name = null);
    }
    function member_delete(model){
        controller_actions[model + '_user'].delete(models[model].user_id)
        .then(x => ok_reload(x, () => actions[model].get_one('members')))
        .then(models[model].user_id = null);
    }
    function selectedfmember(model, x){
        models[model].user_id = x;
        if(model == 'task') taskuserpp = x && controller_actions.task_user.get_one(x);
    }
    let all_label = $state();
    function tabs(tab){
        pp = null;
        taskpp = null;
        switch(tab){
            case 'projects':
                project();
                break;
            case 'kit_types':
                actions.kit_type.get_all();
                all_label = "All Kit Types";
                break;
            case 'features':
                actions.feature.get_all();
                all_label = "All Features";
                break;
            case 'workflows':
                actions.workflow.get_all();
                all_label = "All Workflows";
                break;
            case 'groups':
                actions.group.get_all();
                all_label = "All Groups";
                break;
            case 'invites':
                actions.invite.get_all();
                all_label = "All Invites";
                break;
            case 'archive':
                if(admin) get_archives();
                break;
        }
    }


    const models = $state({
        kit_type: {
            label: 'Kit Type',
            desc: 'A Kit Type holds parameters for kit behavior.',
            id: null,
            index: null
        },
        kit: {
            label: 'Kit',
            desc: 'A Kit is a unit of work.',
            id: null,
            index: null
        },
        donekit: {
            label: 'Done Kit',
            desc: 'A Kit is a unit of work.',
            id: null,
            index: null
        },
        project: {
            label: 'Project',
            desc: 'A Project is a set of Tasks and a set of Users.',
            id: null,
            index: null,
            tab: 'info',
            user_id: null,
            user_index: null
        },
        task: {
            label: 'Task',
            desc: 'A Task is a set of Kits and a set of Users.',
            id: null,
            index: null,
            tab: 'info',
            user_id: null,
            user_index: null
        },
        feature: {
            label: 'Feature',
            desc: 'A Feature is an attribute of an object.',
            id: null,
            index: null
        },
        workflow: {
            label: 'Workflow',
            desc: 'A Workflow controls kit assignment.',
            id: null,
            index: null
        },
        group: {
            label: 'Group',
            desc: 'A Group is a set of Users.',
            id: null,
            index: null,
            tab: 'info',
            user_id: null,
            user_index: null
        },
        invite: {
            label: 'Invite',
            desc: 'An invitation for a new user.',
            id: null,
            index: null
        }
    });
    const actions = $derived.by(() => {
        const model_actions = {};
        for(let x in controller_actions){
            model_actions[x] = {};
            model_actions[x].get_all = () => {
                tabp = controller_actions[x].get_all();
                models[x].id = null;
            };
            model_actions[x].get_one = () => pp = controller_actions[x].get_one(models[x].id);
            model_actions[x].create = () => controller_actions[x].create(create_name()).then(y => response(y, model_actions[x].get_all));
            model_actions[x].delete = () => controller_actions[x].delete(models[x].id).then(y => response(y, model_actions[x].get_all, () => models[x].id = null));
            model_actions[x].patch = (y) => controller_actions[x].patch(models[x].id, y);
        }
        // overrides
        model_actions.project.get_one = (x) => {
            pp = controller_actions.project.get_one(models.project.id);
            taskpp = null;
            models.project.user_id = null;
            models.project.tab = x || 'info';
            // memberf = (name) => controller_actions.project_user.not_in(models.project.id, name);
        };
        model_actions.project_user.patch = (x) => controller_actions.project_user.patch(models.project.user_id, x);
        model_actions.task.get_one = (x) => {
            console.log(x)
            taskpp = controller_actions.task.get_one(models.project.id, models.task.id)
            .then(x => {
                x.statuses = [ 'active', 'inactive' ];
                x.workflow = null;
                x.workflows_menu = [];
                for(let y of x.workflows){
                    if(
                        (
                            y.name != 'Bucket' &&
                            y.name != 'BucketUser' &&
                            y.name != 'SecondPass'
                        )
                        ||
                        y.id == x.workflow_id
                    ){
                        x.workflows_menu.push(y);
                    }
                    if(y.id == x.workflow_id){
                        x.workflow = y;
                        // break;
                    }
                }
                for(let y of x.kit_types){
                    if(y.id == x.kit_type_id){
                        x.kit_type = y;
                        break;
                    }
                }
                x.data_sets = [ { id: null, name: 'none'} ].concat(x.data_sets);
                for(let y of x.data_sets){
                    if(y.id == x.data_set_id){
                        x.data_set = y;
                        break;
                    }
                }
                x.menu_tasks = [ { id: 0, name: 'none'} ].concat(x.tasks);
                if(x.meta['1p_task_id']){
                    for(let y of x.tasks){
                        if(y.id == Number(x.meta['1p_task_id'])){
                            x.menu_task = y;
                            break;
                        }
                    }
                }
                else{
                    x.menu_task = x.menu_tasks[0];
                }
                x.constraintb = {};
                for(let y of x.features){
                    if(y.name == y.value) x.constraintb[y.name] = x.meta[y.name] == y.name;
                    else                  x.constraintb[y.name] = x.meta[y.name];
                }
                console.log('taskusers', x)
                // models.task.task_admin_bool = x.task_admin_bool;
                // models.task.members = x.members;
                return x;
            });
            models.task.user_id = null;
            models.task.tab = x || 'info';
            taskuserpp = null;
            kitsp = null;
            donekitsp = null;
            // memberf = (name) => controller_actions.task_user.not_in(models.task.id, name);
        };
        model_actions.task.create = () => {
            controller_actions.task.create(models.project.id, create_name())
            .then(y => response(y, () => model_actions.project.get_one('tasks')));
        };
        model_actions.task.delete = () => {
            controller_actions.task.delete(models.task.id)
            .then(y => response(y, () => model_actions.project.get_one('tasks'), () => models.task.id = null));
        };
        model_actions.task_user.patch = (x) => controller_actions.task_user.patch(models.task.user_id, x);
        model_actions.kit_type.get_one = () => {
            pp = controller_actions.kit_type.get_one(models.kit_type.id)
            .then(x => {
                for(let y of x.node_classes){
                    if(y.id == x.node_class_id){
                        x.node_class = y;
                        break;
                    }
                }
                x.constraintb = {};
                for(let y of x.features){
                    if(y.name == y.value) x.constraintb[y.name] = x.constraints[y.name] == y.name;
                    else                  x.constraintb[y.name] = x.constraints[y.name];
                }
                return x;
            });
        };
        model_actions.feature.create = () => {
            const { category } = create_category();
            const { name } = create_name();
            controller_actions.feature.create({ category, name })
            .then(x => response(x, model_actions.feature.get_all));
        };
        // model_actions.group.get_one = () => {
        //     pp = controller_actions.group.get_one(models.group.id);
        //     .then( x => {
        //         x.group_admin_bool
        //     });
        //     // memberf = (name) => controller_actions.group_user.not_in(models.group.id, name);
        // };
        return model_actions;
    });

    const task_user_states = [ null, 'needs_kit', 'has_kit', 'hold', 'paused' ];

    // let kitsp = $derived( () => models.task.tab == 'kits' ? getp(`/kits/task/${task_id}`));
    $effect( () =>  {
        if(models.task.tab == 'kits'){
            // taskpp.then( (x) => get_kitsp(x.id) );
            // taskpp.then( console.log('there'))
            get_kitsp();
        }
    } );
    $effect( () =>  {
        if(models.task.tab == 'done'){
            get_donekitsp();
        }
    } );
    // export let reload;
    // let name;
    // setInterval( () => {
    //     console.log(models.task.task_admin_bool);
    // }, 1000)
    function get_kitsp(task_id){
        // setTimeout( () => console.log(task_id), 1000);
        // return;
        kitspp = null;
        // console.log(models.task.members)
        kitsp = get_kits_for_task(models.task.id).then( (x) => {
            return x;
        } );
        // donekitsp = kitsp.then(x => x.filter(x => x.state == 'done'));
    }
    function get_donekitsp(task_id){
        kitspp = null;
        // console.log(models.task.members)
        donekitsp = get_kits_for_task(models.task.id).then( (x) => {
            return x;
        } ).then(x => x.filter(x => x.state == 'done'));
    }
    
    function responsex(data){
        let flash_value;
        if(!data){
            toast.error('bad response');
        }
        else if(data.error){
            flash_value = data.error.join(' ');
            toast.error(flash_value);
        }
        else{
            if(data.deleted){
                flash_value = data.deleted;
            }
            else if(data.uids){
                flash_value = `${data.uids.success.length} modified, ${data.uids.error.length} failed`;
                get_kitsp();
            }
            else{
                flash_value = "created " + data.task.name;
            }
            toast.success(flash_value);
            // setTimeout( () => reload() , 1000 );
        }
    }
    function open_kit(){
        kitspp = show_kit(models.kit.id);
    }
    function back(){
        kitspp = null;
    }
    let kits_for_task_table = $state();
    let donekits_for_task_table = $state();
    function reassign(project_id, task_id){
        let uids = [];
        for(let x of kits_for_task_table.get_matched()){
            uids.push(x.uid);
        }
        let o = { uids: uids.join(',') };
        if(!kits_for_task_table.match_attempted()){
            toast.error("you haven't matched any kits");
        }
        else if(new_user || new_state){
            if(new_user){
                o.new_user = new_user.name;
            }
            if(new_state){
                o.new_state = new_state;
            }
            reassign_kits_for_task(project_id, task_id, o).then(responsex);
        }
        else{
            toast.error('neither user nor state specified');
        }
    }
    let new_user = $state();
    let new_state = $state();
    let states = [ 'unassigned', 'assigned', 'done', 'broken', 'excluded', 'priority' ];
    let emptyv = { name: '' };






    const parse_jsonn = (x) => JSON.parse(x);
    let typed = $state();
    let json_typed = $state();
    let files = $state();
    let text_upload = $state();
    let json_upload = $state();
    function parse_kits(text){
        const j = [];
        for(let x of text.split("\n")){
            if(x.length) j.push( { docid: x } );
        }
        return j;
    }
    let tdf = $state(false);
    let jsonn;
    function upload(){
        const r = new FileReader();
        let o = null;
        r.onload = function(e){
            text_upload = e.target.result;
            if(text_upload.match(/^\S+\n/)){
                tdf = true;
            }
        }
        r.readAsText(files[0]);
    }
        // that.w.add_timestamps2 data
        // $('#browse_b').html 'working...'
        // ldc_annotate.add_callback ->
        //     $('.Root').show()
        //     $('#browse_b').hide()
    function add(task_id, json){
        const j = { task_id: task_id, kits: json };
        create_kits_from_kits_tab(j).then( (data) => {
            console.log(data);
            get_kitsp();
        });
    }


    let textt = $state();
    let json_download = $state(false);
    let include_headers = $state(false);
    let filename = $state();
    let link = $state();
    let url = $state();
    let downloadp = $state(Promise.resolve({}));
    function create_download(task_id){
        downloadp = get_kits_for_task_all(task_id).then( (data) => {
            const t = [];
            const zip = new JSZip();
            const folder = zip.folder('transcripts');
            let text;
            for(let kit of data){
                for(let s of kit.segments){
                    s.section = { name: s.section };
                }
                let text = create_transcript(kit.kit_uid, include_speaker, include_section, include_headers, kit.segments);
                if(!textt) textt = text;
                folder.file(`${kit.kit_uid}.tsv`, text);
            }
            zip.generateAsync({type: 'blob'}).then( (blob) => {
                url = URL.createObjectURL(blob);
                tick().then( () => link.href = url );
            })
        });
    }
    let include_speaker = $state(false);
    let include_section = $state(false);


    const user_none = { user_id: 0, name: 'none'};
    function menu_userf(user_id, task_users){
        if(user_id){
            for(let x of task_users){
                if(x.user_id == user_id) return x;
            }
            // error if not found?
        }
        else{
            return user_none;
        }
    }


    // const h = {
    //     name: 'create_invitation_modal',
    //     // delegate: ns,
    //     // b: 'DELETE',
    //     // f: "delete_section_from_modal",
    //     // ff: delete_selected,
    //     title: 'Send Invitation',
    //     h: '',
    //     buttons: [
    //         [ 'Send', cbtn, create_invite ]
    //     ]
    // };
    // let email = $state();
    // let role = $state();
    // let project_id = $state();
    // let task_id = $state();
    // function create_invite(){
    //     postp(
    //         "/invites",
    //         {
    //             email: email,
    //             role: role,
    //             task_id: task_id,
    //             project_id: project_id
    //         }
    //       ).then( (data) => {
    //             let flash_value;
    //             if(!data){
    //                 toast.error('bad response');
    //             }
    //             if(data.errors){
    //                 flash_value = data.errors.join(' ');
    //                 toast.error(flash_value);
    //             }
    //             else{
    //                 flash_value = "sent to " + data.invite.email;
    //                 toast.success(flash_value);
    //                 get();
    //             }
    //         }
    //       );
    // }

    let picsp = $state();
    function list(){
        let bucket = 'ldc-northwell-data';
        let prefix = 'vital';
        let contents;
        let error;
        const params = {
            Bucket: bucket,
            Prefix: prefix
        };
        if(!(admin || portal_manager || project_manager)) return;
        picsp = listObjectsV2params(params).then(res => {
            // console.log(res)
            if(res.Contents){
                contents = res.Contents.map( obj => {
                    // console.log(obj)
                    return {Key:obj.Key, Size: obj.Size, LastModified: obj.LastModified}
                });
            }
            else{
                contents = [];
            }
            // console.log(contents);
            return contents;
        })
        .catch(e => error = e);
    }
    function geto(){
        get_json_object('ldc-northwell-data', 'vital/testt.json').then( x => console.log(x) );
        // getSignedUrlPromise('ldc-northwell-data', 'vital/testt.json').then(x => console.log(x));
    }
    // geto();
    list();

    async function upload3(file){
        console.log(file);
        const filename = `${Math.random().toString().substring(2,12)}`
        const fn = `vital/uploads/${filename}`
        uploadObject('ldc-northwell-data', fn, file);
    }

    function done(){
        setTimeout(list, 1000);
    }

    let selectedfkey = $state();
    let selectedforiginal = $state();
    function selectedfupload(x){
        selectedfkey = x;
        headObject('ldc-northwell-data', x).then(x => {
            // Decode filename if it was base64 encoded
            if (x.Metadata['filename-encoding'] === 'base64-utf8' || !x.Metadata.filename.match(/\./)) {
                selectedforiginal = decodeURIComponent(escape(atob(x.Metadata.filename)));
            } else {
                selectedforiginal = x.Metadata.filename;
            }
        })
    }

    let responsesp = $state();
    responsesp = getp(`/response_sets?kit_id=all`).then( (x) => {
        console.log('sets');
        console.log(x);
        return x;
    });
    let selectedfkeyresponse = $state();
    function selectedfresponse(x){
    }
    let skipIndex = {};
    let selectedSkipRow = $state(null);
    let skipResult = $state(null);
    let skipCount = $state(1);
    // VITAL users, and HCs, whose names are Prolific IDs (as in PagesController#controls_studies)
    function skippable_user(x){
        return /^VITAL\d{3}$/.test(x) || /^\w{24}$/.test(x);
    }
    function selectedfskip(x){
        selectedSkipRow = skipIndex[x] || null;
        skipResult = null;
    }
    function skip_session(){
        postp('/response_sets/skip_session', { id: selectedSkipRow?.id, count: skipCount }).then(x => {
            skipResult = x?.result || x?.error || 'no response from server';
        });
    }
    let archivesp = $state();
    let archiveConfirm = $state(null);
    let archiveResult = $state(null);
    function get_archives(){
        archivesp = getp('/response_sets/archives').then(x => (x || []).map(r => {
            r.session_combined = `${r.sessionn}-${r.session}`;
            mod_field(r, 'kit_uid');
            r.archived_text = r.archived ? 'yes' : 'no';
            r.archive_button = r.archived ? '' : 'Archive';
            return r;
        }));
    }
    function archive_response_set(){
        let id = archiveConfirm.id;
        archiveConfirm = null;
        postp('/response_sets/archive', { id: id }).then(x => {
            archiveResult = x?.result || x?.error || 'no response from server';
            get_archives();
            // the row is gone from response_sets, so the Responses and Skip tabs need it too
            responsesp = getp(`/response_sets?kit_id=all`);
        });
    }
    function click_response(x, y){
        console.log(x);
        console.log(y);
        selectedfkeyresponse = x[y.replace('_short','')];
        transcriptp = null;
    }
    function mod_rows(x){
        x.forEach(x => {
            // mod_field(x, 'session');
            x.session_combined = `${x.sessionn}-${x.session}`;
            mod_field(x, 'kit_uid');
            mod_field(x, 'response1');
            mod_field(x, 'response2');
            mod_field(x, 'response3');
            x.bypass = 'bypass'
        });
        return x;
    }
    function mod_field(x, f){
        if(x[f]) x[`${f}_short`] = x[f][0] + "..." + x[f].slice(-3);
    }
    const response_download_columns = [
        [ 'ID', 'id' ],
        [ 'User', 'user_id' ],
        [ 'Session', 'session_combined' ],
        [ 'Kit', 'kit_uid' ],
        [ 'Picture', 'picture' ],
        [ 'Response1', 'response1' ],
        [ 'Response2', 'response2' ],
        [ 'Response3', 'response3' ],
        [ 'Response4', 'response4' ],
        [ 'Modified', 'updated_at' ]
    ];
    function download_tsv(rows, columns, name){
        const url = create_download_url(create_download_tsv(rows, columns, true, 'yes'));
        const a = document.createElement('a');
        a.href = url;
        a.download = name;
        a.click();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
    function download_responses(rows){
        download_tsv(rows, response_download_columns, 'responses.tsv');
    }
    let transcriptp = $state();
    function check_transcript(){
        // transcriptp = postp('/rev', { uid: selectedfkeyresponse });
        transcriptp = get_json_object('ldc-northwell-data', `vital/transcripts/${selectedfkeyresponse}.json`);
    }
    let waiting_on_rev = $state();
    function send_to_rev(){
        waiting_on_rev = 1;
        getSignedUrlPromise('ldc-northwell-data', `vital/collection/${selectedfkeyresponse}.wav`)
        .then(get_hlt_promiseyrev_copy)
        .then( x => {
            console.log(x);
            waiting_on_rev = 2;
            setTimeout(() => { waiting_on_rev = null; transcriptp = null }, 2000);
        });
    }
function get_hlt_promiseyrev_copy(url){
  return postp("/rev", { url: url }).then((x) => {
    let id = x.id;
    return new Promise( (resolve, reject) => {
      const f = () => {
        console.log("checking for rev job " + id);
        postp("/rev", { id: id, uid: selectedfkeyresponse }).then((x) => {
          if(x && x.length){
            console.log('found transcript');
            console.log(x[0]);
            resolve(x);
          }
          else{
            setTimeout(f, 1000);
          }
        });
      };
      setTimeout(f, 30000);
    });
  });
}


    let eventsp = $state();
    let events_kit_uid = $state('');
    function get_events(){
        const q = events_kit_uid ? `?kit_uid=${encodeURIComponent(events_kit_uid.trim())}` : '';
        eventsp = getp(`/recording_events${q}`);
    }
    get_events();
    const event_download_columns = [
        [ 'ID', 'id' ],
        [ 'Time', 'created_at' ],
        [ 'User', 'user_id' ],
        [ 'Kit', 'kit_uid' ],
        [ 'Session', 'session' ],
        [ 'Source', 'source' ],
        [ 'Category', 'category' ],
        [ 'Event', 'name' ],
        [ 'Ok', 'ok' ],
        [ 'File', 'filename' ],
        [ 'Seq', 'seq' ],
        [ 'Detail', 'detail' ]
    ];
    function download_events(rows){
        download_tsv(rows || [], event_download_columns, 'recording_events.tsv');
    }

    let passesp = $state();
    function get_passes(){
        passesp = getp(`/passes`).then( (x) => {
            console.log('passes');
            console.log(x);
            return x;
        });
    }
    get_passes();
    let selectedfkeypass = $state();
    function selectedfpass(x){
    }

    let bypasscreated = $state(false);
    function click_bypass(x, y){
        console.log(x);
        console.log(y);
        // selectedfkeyresponse = x[y.replace('_short','')];
        // transcriptp = null;
        postp('/passes', { kit_uid: x.kit_uid }).then(x => {
            bypasscreated = true;
            toast.success('By Pass Created');
            get_passes();
            setTimeout(() => bypasscreated = false, 3000);
        });
    }

</script>

<style>
</style>

{#snippet audioLoader(s3Key)}
    <div class="mb-6x">
        {#await getSignedUrlPromise('ldc-northwell-data', s3Key)}
            <div class="text-center py-4">Loading audio...</div>
        {:then v}
            <AudioPlayer url={v} blob={null} filename="foo" play={true} />
        {/await}
    </div>
{/snippet}

<Toaster richColors expand={true} />

<Help {help}>
    {#snippet content()}
    <div>
        <p>Help Mode On</p>
        <p>more info can be found on each tab</p>
    </div>
    {/snippet}
</Help>

<div>
    {#if admin}
        <div>
          jump to readonly
          <input class="jtro">
        </div>
    {/if}
</div>

<button class="{btn} bg-blue-200 float-right" onclick={() => help = !help}>Help</button>

{#snippet dialog_create(model)}
    <Dialog.Root>
        <Dialog.Trigger class={buttonVariants({ variant: "secondary" })}>Create {models[model].label}</Dialog.Trigger>
        <Dialog.Content>
            <Dialog.Header>
                <Dialog.Title>Create {models[model].label}</Dialog.Title>
                <Dialog.Description>
                    {models[model].desc}
                </Dialog.Description>
            </Dialog.Header>
            {#if model == 'feature'}
                <Label for="dialog_create_category">Category</Label>
                <Input type="text" id="dialog_create_category" placeholder="Category" />
            {/if}
            <Label for="dialog_create_name">Name</Label>
            <Input type="text" id="dialog_create_name" placeholder="Name" />
            <Dialog.Footer>
                <Button variant="secondary" onclick={actions[model].create}>Create</Button>
            </Dialog.Footer>
        </Dialog.Content>
    </Dialog.Root>
{/snippet}

{#snippet dialog_delete(model)}
    <Dialog.Root>
        <Dialog.Trigger class={buttonVariants({ variant: "secondary" })}>Delete {models[model].label}</Dialog.Trigger>
        <Dialog.Content>
            <Dialog.Header>
                <Dialog.Title>Delete {models[model].label}</Dialog.Title>
                <Dialog.Description>
                    This will delete the {models[model].label} {models[model].index[models[model].id].name}, are you sure you want to do this?
                </Dialog.Description>
            </Dialog.Header>
            <Dialog.Footer>
                <Button variant="destructive" onclick={actions[model].delete}>Delete</Button>
            </Dialog.Footer>
        </Dialog.Content>
    </Dialog.Root>
{/snippet}

{#snippet dialog_create_member(model)}
    <Dialog.Root>
        <Dialog.Trigger class={buttonVariants({ variant: "secondary" })}>Add Member</Dialog.Trigger>
        <Dialog.Content style="width: 800px; max-width: 800px;">
            <Dialog.Header>
                <Dialog.Title>Add Member</Dialog.Title>
                <Dialog.Description>
                    Add User to {models[model].label}
                </Dialog.Description>
            </Dialog.Header>
            <div class="grid grid-cols-2">
                <div>
                    <Label for="dialog_create_member_name">Name</Label>
                    <Input type="text" id="dialog_create_member_name" placeholder="Name" bind:value={member_name} />
                </div>
                <div>
                    {#await memberp}
                        names
                    {:then v}
                        {#each v as x}
                            {#if x.name.includes(member_name)}
                                <button class="{buttonVariants({ variant: "secondary" })} m-2" onclick={() => member_create(model, x)}>{x.name}</button>
                            {/if}
                        {/each}
                    {/await}
                </div>
            </div>
            <!-- <Dialog.Footer>
                <Button variant="secondary" onclick={f}>Create</Button>
            </Dialog.Footer> -->
        </Dialog.Content>
    </Dialog.Root>
{/snippet}

{#snippet dialog_delete_member(model)}
    <Dialog.Root>
        <Dialog.Trigger class={buttonVariants({ variant: "secondary" })}>Remove Member</Dialog.Trigger>
        <Dialog.Content>
            <Dialog.Header>
                <Dialog.Title>Remove Member</Dialog.Title>
                <Dialog.Description>
                    This will remove {models[model].user_index[models[model].user_id].name}, are you sure you want to do this?
                </Dialog.Description>
            </Dialog.Header>
            <Dialog.Footer>
                <Button variant="destructive" onclick={() => member_delete(model)}>Delete</Button>
            </Dialog.Footer>
        </Dialog.Content>
    </Dialog.Root>
{/snippet}

{#snippet boiler1(model)}
    {@render boiler2(model)}
    {#await pp}
        <div class="mx-auto w-8 h-8"><Spinner /></div>
    {:then v}
        {@render boiler4(v)}
        {@render boiler5(model, v)}
    {/await}
{/snippet}

{#snippet boiler2(model)}
    <div class="float-right">
        <button class="{btn}" onclick={() => (pp = null) || actions[model].get_all()}>Return to {models[model].label} list</button>
    </div>
{/snippet}

{#snippet boiler4(v)}
    <div class="float-right p-2">{v.name}</div>
{/snippet}

{#snippet boiler5(model, v)}
    <div class="w-96 mx-auto">
        <div>ID: {v.id}</div>
        {#if model == 'feature'}
            <Patch type="input" urlf={actions[model].patch} label="Category" key="category" value={v.category} />
        {/if}
        {#if model == 'project' && !v.project_owner_bool}
            <div>Name: {name}</div>
        {:else}
            <Patch type="input" urlf={actions[model].patch} label="Name" key="name" value={v.name} />
        {/if}
        {#if model == 'task'}
            {models.task.tab}
            <Patch type="select" urlf={actions[model].patch} label="Status" key="status" value={v.status} values={v.statuses} />
            <Patch type="select" urlf={actions[model].patch} label="Workflow" key="workflow_id" value={v.workflow} values={v.workflows_menu} att="name" />
            <Patch type="select" urlf={actions[model].patch} label="KitType" key="kit_type_id" value={v.kit_type} values={v.kit_types} att="name" />
            <Patch type="select" urlf={actions[model].patch} label="DataSet" key="data_set_id" value={v.data_set} values={v.data_sets} att="name" />
            {#each v.features as x}
                {#if x.name == x.value}
                    <Patch type="checkbox" urlf={actions[model].patch} label={x.label} key={x.name} value={v.constraintb[x.name]} meta="meta" />
                {:else if x.name == '1p_task_id'}
                    <Patch type="select" urlf={actions[model].patch} label={x.label} key={x.name} value={v.menu_task} values={v.menu_tasks} att="name" meta="meta" />
                {:else if x.name == 'docid' || x.name == 'notes' || x.name == 'dual_percentage' || x.name == 'dual_minimum_duration'}
                    <Patch type="input" urlf={actions[model].patch} label={x.label} key={x.name} value={v.constraintb[x.name]} meta="meta" />
                {:else}
                    <Patch type="input" urlf={actions[model].patch} label={x.label} key={x.name} value={v.constraintb[x.name]} />
                {/if}
            {/each}
            <div>
                {#if v.bucket}
                    Bucket {v.bucket} has {v.bucket_size} files
                {:else}
                    no bucket for this task
                {/if}
            </div>
        {/if}
        {#if model == 'kit_type'}
            <Patch type="select" urlf={actions[model].patch} label="Namespace" key="node_class_id" value={v.node_class} values={v.node_classes} att="name" />
            {#each v.features as x}
                {#if x.name == x.value}
                    <Patch type="checkbox" urlf={actions[model].patch} label={x.label} key={x.name} value={v.constraintb[x.name]} meta="constraints" />
                {:else if x.value == 'comma'}
                    <Patch type="input" urlf={actions[model].patch} label={x.label} key={x.name} value={v.constraintb[x.name]} meta="constraints" split="," />
                {:else}
                    <Patch type="input" urlf={actions[model].patch} label={x.label} key={x.name} value={v.constraintb[x.name]} meta="constraints" />
                {/if}
            {/each}
        {:else if model == 'feature'}
            <Patch type="input" urlf={actions[model].patch} label="Value" key="value" value={v.value} />
            <Patch type="input" urlf={actions[model].patch} label="Label" key="label" value={v.label} />
            <Patch type="textarea" urlf={actions[model].patch} label="Description" key="description" value={v.description} textarea={true} />
        {:else if model == 'workflow'}
            <Patch type="textarea" urlf={actions[model].patch} label="Description" key="description" value={v.description} textarea={true} />
            <Patch type="select" urlf={actions[model].patch} label="Type" key="type" value={v.type} values={v.types} />
        {/if}
    </div>
{/snippet}

{#snippet boiler3(model, p1, p2)}
    <div class="flex justify-around">
        <div>{all_label}</div>
        {#if models[model].id && models[model].index}
            <div>
                <button class={buttonVariants({ variant: "secondary" })} onclick={() => actions[model].get_one()}>Open</button>
            </div>
            {@render boiler7(model)}
            {#if p1}
                {@render dialog_delete(model)}
            {/if}
        {:else}
            Select a {models[model].label} in the table for more options.
        {/if}
        {#if p2}
            {@render dialog_create(model)}
        {/if}
    </div>
{/snippet}

{#snippet member_table(model, v, columns)}
    <Table
        indexf={x => models[model].user_index = x}
        {columns}
        rows={v.members}
        selectedf={(x) => selectedfmember(model, x)}
    />
{/snippet}


{#snippet member_tab(model, v)}
    {#if models[model].tab == "members"}
        <div class="flex justify-around">
            <div>Members</div>
            {#if v[model + '_admin_bool']}
                {#if models[model].user_id}
                    {@render dialog_delete_member(model)}
                {/if}
                {@render dialog_create_member(model)}
            {/if}
        </div>
        <div class="flex justify-aroundx p-6">
            <div class="float-leftx col-6 w-1/2">
                {#if model == 'project'}
                    {@render member_table(model, v, [
                        [ 'User ID', 'user_id', 'col-1' ],
                        [ 'Name', 'name', 'col-2' ],
                        [ 'Owner', 'owner', 'col-1' ],
                        [ 'Admin', 'admin', 'col-1' ]
                    ])}
                {:else if model == 'task'}
                    {@render member_table(model, v, [
                        [ 'User ID', 'user_id', 'col-1' ],
                        [ 'Name', 'name', 'col-2' ],
                        [ 'State', 'state', 'col-1' ],
                        [ 'Admin', 'admin', 'col-1' ]
                    ])}
                {:else if model == 'group'}
                    {@render member_table(model, v, [
                        [ 'User ID', 'user_id', 'col-1' ],
                        [ 'Name', 'name', 'col-2' ]
                    ])}
                {/if}
            </div>
            <div class="float-leftx col-6 p-6 w-1/2">
                {#if models[model].user_id && (v.project_owner_bool || v.task_admin_bool)}
                    {#each v.members as x}
                        {#if x.id == models[model].user_id}
                            {#if model == 'project'}
                                <div class="flex items-center space-x-4">
                                    <Patch type="checkbox" urlf={actions[model + '_user'].patch} label="Owner" key="owner" value={x.owner} reload={() => actions[model].get_one('members')} />
                                    <Patch type="checkbox" urlf={actions[model + '_user'].patch} label="Admin" key="admin" value={x.admin} reload={() => actions[model].get_one('members')} />
                                </div>
                            {:else if model == 'task'}
                                <div class="w-1/2">
                                    <Patch type="checkbox"   urlf={actions[model + '_user'].patch} label="Admin" key="admin" value={x.admin} reload={() => actions[model].get_one('members')} />
                                    {#if task_user_states.includes(x.state)}
                                        <Patch type="select" urlf={actions[model + '_user'].patch} label="State" key="state" value={x.state} reload={() => actions[model].get_one('members')} values={task_user_states} />
                                    {:else}
                                        Error
                                    {/if}
                                </div>
                                <div class="my-4">
                                    {#if taskuserpp}
                                        {#await taskuserpp}
                                            <div class="mx-auto w-8 h-8"><Spinner /></div>
                                        {:then v}
                                            <pre>
                                                {v.ok}
                                            </pre>
                                        {/await}
                                    {/if}
                                </div>
                            {/if}
                        {/if}
                    {/each}
                {/if}
            </div>
        </div>
    {/if}
{/snippet}

{#snippet boiler7(model)}
    {#if style}
        <div {style}>
            {#if model == 'project'}
                <div><button class={buttonVariants({ variant: "secondary" })} onclick={() => actions[model].get_one()}>Open Project Info</button></div>
                <div><button class={buttonVariants({ variant: "secondary" })} onclick={() => actions[model].get_one('tasks')}>Open Task List</button></div>
            {:else if model == 'task'}
                <div><button class={buttonVariants({ variant: "secondary" })} onclick={() => actions[model].get_one()}>Open Task Info</button></div>
                <div><button class={buttonVariants({ variant: "secondary" })} onclick={() => actions[model].get_one('kits')}>Open Kit List</button></div>
            {:else}
                <div><button class={buttonVariants({ variant: "secondary" })} onclick={() => actions[model].get_one()}>Open</button></div>
            {/if}
        </div>
    {/if}
{/snippet}

<!-- <PageTabs {pages} {page} on:page={pagef} {admin} {lead_annotator} {help} on:help={helpf} /> -->

<Tabs.Root bind:value={tab} class="w-full justify-center" onValueChange={tabs}>
    <Tabs.List>
        <Tabs.Trigger value="tasks">
            <Tooltip.Provider>
                <Tooltip.Root>
                    <Tooltip.Trigger>Work</Tooltip.Trigger>
                    <Tooltip.Content>your tasks with links to start</Tooltip.Content>
                </Tooltip.Root>
            </Tooltip.Provider>
        </Tabs.Trigger>
        <Tabs.Trigger value="projects">
            <Tooltip.Provider>
                <Tooltip.Root>
                    <Tooltip.Trigger>Projects</Tooltip.Trigger>
                    <Tooltip.Content>projects, tasks, kits</Tooltip.Content>
                </Tooltip.Root>
            </Tooltip.Provider>
        </Tabs.Trigger>
        <Tabs.Trigger value="browse">
            <Tooltip.Provider>
                <Tooltip.Root>
                    <Tooltip.Trigger>Browse</Tooltip.Trigger>
                    <Tooltip.Content>browse uploaded files</Tooltip.Content>
                </Tooltip.Root>
            </Tooltip.Provider>
        </Tabs.Trigger>
        <Tabs.Trigger value="kit_types">
            <Tooltip.Provider>
                <Tooltip.Root>
                    <Tooltip.Trigger>Kit Types</Tooltip.Trigger>
                    <Tooltip.Content>tasks require a kit type</Tooltip.Content>
                </Tooltip.Root>
            </Tooltip.Provider>
        </Tabs.Trigger>
        <Tabs.Trigger value="features">
            <Tooltip.Provider>
                <Tooltip.Root>
                    <Tooltip.Trigger>Features</Tooltip.Trigger>
                    <Tooltip.Content>features for different objects</Tooltip.Content>
                </Tooltip.Root>
            </Tooltip.Provider>
        </Tabs.Trigger>
        <Tabs.Trigger value="workflows">
            <Tooltip.Provider>
                <Tooltip.Root>
                    <Tooltip.Trigger>Workflows</Tooltip.Trigger>
                    <Tooltip.Content>workflows</Tooltip.Content>
                </Tooltip.Root>
            </Tooltip.Provider>
        </Tabs.Trigger>
        <Tabs.Trigger value="groups">
            <Tooltip.Provider>
                <Tooltip.Root>
                    <Tooltip.Trigger>Groups</Tooltip.Trigger>
                    <Tooltip.Content>users can be added to groups</Tooltip.Content>
                </Tooltip.Root>
            </Tooltip.Provider>
        </Tabs.Trigger>
        <Tabs.Trigger value="invites">
            <Tooltip.Provider>
                <Tooltip.Root>
                    <Tooltip.Trigger>Invites</Tooltip.Trigger>
                    <Tooltip.Content>users can be invited</Tooltip.Content>
                </Tooltip.Root>
            </Tooltip.Provider>
        </Tabs.Trigger>
        <Tabs.Trigger value="permissions">
            <Tooltip.Provider>
                <Tooltip.Root>
                    <Tooltip.Trigger>Permissions</Tooltip.Trigger>
                    <Tooltip.Content>explore roles and permissions</Tooltip.Content>
                </Tooltip.Root>
            </Tooltip.Provider>
        </Tabs.Trigger>
        <Tabs.Trigger value="pictures">
            <Tooltip.Provider>
                <Tooltip.Root>
                    <Tooltip.Trigger>Uploads</Tooltip.Trigger>
                    <Tooltip.Content>available uploads</Tooltip.Content>
                </Tooltip.Root>
            </Tooltip.Provider>
        </Tabs.Trigger>
        <Tabs.Trigger value="responses">
            <Tooltip.Provider>
                <Tooltip.Root>
                    <Tooltip.Trigger>Responses</Tooltip.Trigger>
                    <Tooltip.Content>available responses</Tooltip.Content>
                </Tooltip.Root>
            </Tooltip.Provider>
        </Tabs.Trigger>
        <Tabs.Trigger value="skip">
            <Tooltip.Provider>
                <Tooltip.Root>
                    <Tooltip.Trigger>Skip</Tooltip.Trigger>
                    <Tooltip.Content>skip sessions for VITAL and HC users</Tooltip.Content>
                </Tooltip.Root>
            </Tooltip.Provider>
        </Tabs.Trigger>
        <Tabs.Trigger value="archive">
            <Tooltip.Provider>
                <Tooltip.Root>
                    <Tooltip.Trigger>Archive</Tooltip.Trigger>
                    <Tooltip.Content>archive response sets (admins only)</Tooltip.Content>
                </Tooltip.Root>
            </Tooltip.Provider>
        </Tabs.Trigger>
        <Tabs.Trigger value="passes">
            <Tooltip.Provider>
                <Tooltip.Root>
                    <Tooltip.Trigger>By Pass</Tooltip.Trigger>
                    <Tooltip.Content>passes</Tooltip.Content>
                </Tooltip.Root>
            </Tooltip.Provider>
        </Tabs.Trigger>
        <Tabs.Trigger value="events">
            <Tooltip.Provider>
                <Tooltip.Root>
                    <Tooltip.Trigger>Events</Tooltip.Trigger>
                    <Tooltip.Content>diagnostic trail for recording sessions</Tooltip.Content>
                </Tooltip.Root>
            </Tooltip.Provider>
        </Tabs.Trigger>
        <Tabs.Trigger value="releases">
            <Tooltip.Provider>
                <Tooltip.Root>
                    <Tooltip.Trigger>Releases</Tooltip.Trigger>
                    <Tooltip.Content>download files from S3</Tooltip.Content>
                </Tooltip.Root>
            </Tooltip.Provider>
        </Tabs.Trigger>
    </Tabs.List>
    <Tabs.Content value="tasks">
        <Help {help}>
            {#snippet content()}
            <div>
                <p>These are your tasks</p>
                <p>The Action column contains links to annotation tools, if work is available</p>
                <p>Clicking on a Project or Task name will jump to the appropriate tab</p>
            </div>
            {/snippet}
        </Help>
            <!-- <UsersTasks {help} {admin} {lead_annotator} {p} {project} {task} /> -->
        {#await p}
            <div class="mx-auto w-8 h-8"><Spinner /></div>
        {:then v}
            <Table
                indexf={x => null}
                columns={[
                    [ 'Project',   'project', 'col-1', 'f', (x, y) => goto(x, y) ],
                    [ 'Task',      'task',    'col-2', 'f', (x, y) => goto(x, y) ],
                    [ 'Action',    'action',  'col-1', 'html' ],
                    [ 'Status',    'state',   'col-1' ],
                    [ 'Done Kits', 'done',    'col-1' ]
                ]}
                rows={v[0]}
                key_column="task"
                selectedf={() => null}
            />
        {/await}
    </Tabs.Content>
    <Tabs.Content value="projects">
        {#if tab == 'projects'}
    <!-- <Projects   {help} {admin} {lead_annotator} {goto_project} {goto_task} {reload2} /> -->
            <Help {help}>
                {#snippet content()}
                    <div>
                        <p>Projects contain Tasks, which in turn contain Kits</p>
                        <p>Select and Open a Project from the table</p>
                        {#if lead_annotator}
                            <p>You also have permission to create a new Project</p>
                        {/if}
                    </div>
                {/snippet}
            </Help>
            {#await tabp}
                <div class="mx-auto w-8 h-8"><Spinner /></div>
            {:then v}
                {#if pp}
                    {@render boiler2('project')}
                    {#await pp}
                        <div class="mx-auto w-8 h-8"><Spinner /></div>
                    {:then v}
                        {@render boiler4(v)}
                        <Tabs.Root bind:value={models.project.tab} class="w-full">
                            <Tabs.List>
                                <Tabs.Trigger value="info">Project Info</Tabs.Trigger>
                                <Tabs.Trigger value="tasks">Project Tasks</Tabs.Trigger>
                                <Tabs.Trigger value="members">Project Members</Tabs.Trigger>
                            </Tabs.List>
                            <Tabs.Content value="info">
                                {@render boiler5('project', v)}
                            </Tabs.Content>
                            <Tabs.Content value="tasks">
                                <Help {help}>
                                    {#snippet content()}
                                        <div>
                                            <p>Tasks contain Kits</p>
                                            <p>Select and Open a Task from the table</p>
                                            {#if v.project_admin_bool}
                                                <p>You also have permission to create a new Task</p>
                                            {/if}
                                        </div>
                                    {/snippet}
                                </Help>
                                {#if taskpp}
                                    <div class="float-right">
                                        <button class="{btn}" onclick={() => (taskpp = null) || actions.project.get_one('tasks')}>Return to Task list</button>
                                    </div>
                                    {#await taskpp}
                                        <div class="mx-auto w-8 h-8"><Spinner /></div>
                                    {:then vv}
                                        {#if vv.error}
                                            <div>Error: {vv.error}</div>
                                        {:else}
                                            <div class="float-right p-2">
                                                {vv.name} {vv.id}
                                            </div>
                                            <!-- <Task {help} {project_admin} {project_id} {task_id} {...v} {project_users} reload={open} {info} /> -->
                                            <!-- {task_id} {task_index[task_id].name} -->
                                            <Tabs.Root bind:value={models.task.tab} class="w-full justify-center">
                                                <Tabs.List>
                                                    <Tabs.Trigger value="info">Task Info</Tabs.Trigger>
                                                    <Tabs.Trigger value="kits">Kits</Tabs.Trigger>
                                                    <Tabs.Trigger value="done">Done Kits</Tabs.Trigger>
                                                    <Tabs.Trigger value="duals">Duals</Tabs.Trigger>
                                                    <Tabs.Trigger value="members">Task Members</Tabs.Trigger>
                                                    <Tabs.Trigger value="batches">Batches</Tabs.Trigger>
                                                    <Tabs.Trigger value="nodes">Nodes</Tabs.Trigger>
                                                    <Tabs.Trigger value="nb">New Batches</Tabs.Trigger>
                                                </Tabs.List>
                                                <Tabs.Content value="info">
                                                    {#if models.task.tab == 'info'}
                                                        {#if v.project_admin_bool}
                                                            {@render boiler5('task', vv)}
                                                        {:else}
                                                            <div class="col-3 mx-auto">
                                                                <div>ID: {vv.id}</div>
                                                                <div>Name: {vv.name}</div>
                                                            </div>
                                                        {/if}
                                                    {/if}
                                                </Tabs.Content>
                                                <Tabs.Content value="kits">
                                                    {#if models.task.tab == 'kits'}
                                                        <!-- <Kits
                                                            {help}
                                                            project_id={v.id}
                                                            task_id={vv.id}
                                                            task_admin={vv.task_admin_bool}
                                                            task_users={vv.members}
                                                        /> -->
                                                        {#await kitsp}
                                                            <div class="mx-auto w-8 h-8"><Spinner /></div>
                                                        {:then rows}
                                                            {#if kitspp}
                                                                <div class="float-right">
                                                                    <button class="{btn}" onclick={back}>Return to kit list</button>
                                                                </div>
                                                                {#await kitspp}
                                                                    <div class="mx-auto w-8 h-8"><Spinner /></div>
                                                                {:then vvv}
                                                                    <!-- <Kit
                                                                        task_admin={vv.task_admin_bool}
                                                                        task_users={vv.members}
                                                                        {...vvv}
                                                                    /> -->
                                                                    {#if vv.task_admin_bool}
                                                                        <div class="col-3 mx-auto">
                                                                            <div>ID: {vvv.id}</div>
                                                                            <div>UID: {vvv.uid}</div>
                                                                            <form onsubmit={()=>null} onpreventDefault={()=>null}>
                                                                                <InputSelect
                                                                                    url={`/kits/${vvv.id}/update`}
                                                                                    label="User"
                                                                                    key="user_id"
                                                                                    value={menu_userf(vvv.user_id, vv.members)}
                                                                                    values={[ user_none ].concat(vv.members)}
                                                                                    att="name"
                                                                                    idk="user_id"
                                                                                />
                                                                            </form>
                                                                        </div>
                                                                    {:else}
                                                                        <div class="col-3 mx-auto">
                                                                            <div>ID: {vvv.id}</div>
                                                                            <div>Name: {vvv.name}</div>
                                                                        </div>
                                                                    {/if}
                                                                        <!-- {project_id} -->
                                                                        <!-- {task_id} -->
                                                                    <!-- {task_id} {kit_index[task_id].name} -->
                                                                {/await}
                                                            {:else}
                                                                <div class="flex justify-around mb-4">
                                                                    {#if vv.task_admin_bool}
                                                                        <div>All Kits</div>
                                                                        <!-- <UploadKitList task_id={vv.id} reload2={get_kitsp} /> -->
                                                                        <Dialog.Root>
                                                                            <Dialog.Trigger class={buttonVariants({ variant: "secondary" })}>Create Kits (Text Input)</Dialog.Trigger>
                                                                            <Dialog.Content>
                                                                                <Dialog.Header>
                                                                                    <Dialog.Title>Create Kits</Dialog.Title>
                                                                                    <Dialog.Description>
                                                                                            Type here
                                                                                    </Dialog.Description>
                                                                                </Dialog.Header>
                                                                                <div>
                                                                                    <textarea
                                                                                    bind:value={typed}
                                                                                    class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-md border-gray-300"
                                                                                    ></textarea>
                                                                                </div>
                                                                                <div>
                                                                                    {#if typed}
                                                                                        {#if json_typed}
                                                                                            <button class="{btn}" onclick={() => add(vv.id, json_typed)} data-close-dialog>Create Kits</button>
                                                                                        {:else}
                                                                                            file appears to be docids
                                                                                            <button class="{btn}" onclick={() => json_typed = parse_kits(typed)}>parse as text</button>
                                                                                        {/if}
                                                                                    {/if}
                                                                                </div>
                                                                                {#if json_typed}
                                                                                    <pre>
                                                                                        {#each json_typed as x}
                                                                                            {JSON.stringify(x) + "\n"}
                                                                                        {/each}
                                                                                    </pre>
                                                                                {:else if typed}
                                                                                    {#if jsonn}
                                                                                        <h5>Original, first 1000 characters</h5>
                                                                                        <pre>{typed.substr(0,999)}</pre>
                                                                                    {:else}
                                                                                        <h5>Original, first 10 lines</h5>
                                                                                        <pre>{typed.split("\n").slice(0,9).join("\n")}</pre>
                                                                                    {/if}
                                                                                {/if}
                                                                                <!-- <Dialog.Footer>
                                                                                    <Button variant="secondary" onclick={() => reassign(v.id, vv.id)}>Reassign</Button>
                                                                                </Dialog.Footer> -->
                                                                            </Dialog.Content>
                                                                        </Dialog.Root>
                                                                        <Dialog.Root>
                                                                            <Dialog.Trigger class={buttonVariants({ variant: "secondary" })}>Create Kits (File Input)</Dialog.Trigger>
                                                                            <Dialog.Content>
                                                                                <Dialog.Header>
                                                                                    <Dialog.Title>Create Kits</Dialog.Title>
                                                                                    <Dialog.Description>
                                                                                            Upload a file
                                                                                    </Dialog.Description>
                                                                                </Dialog.Header>
                                                                                <div>
                                                                                    <input
                                                                                    type="file"
                                                                                    bind:files
                                                                                    class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-md border-gray-300"
                                                                                    >
                                                                                </div>
                                                                                <div>
                                                                                    {#if files && files[0]}
                                                                                        {#if json_upload}
                                                                                            <button class="{btn}" onclick={() => add(vv.id, json_upload)} data-close-dialog>Create Kits</button>
                                                                                        {:else if text_upload}
                                                                                            {#if tdf}
                                                                                                file appears to be docids
                                                                                                <button class="{btn}" onclick={() => json_upload = parse_kits(text_upload)}>parse as text</button>
                                                                                            {:else if jsonn}
                                                                                                file appears to be JSON
                                                                                                <button class="{btn}" onclick={() => json_upload = parse_jsonn(text_upload)}>parse as JSON</button>
                                                                                            {:else}
                                                                                                unknown format
                                                                                            {/if}
                                                                                        {:else}
                                                                                            <button class="{btn}" onclick={upload}>upload</button>
                                                                                        {/if}
                                                                                    {/if}
                                                                                </div>
                                                                                {#if json_upload}
                                                                                    <pre>
                                                                                        {#each json_upload as x}
                                                                                            {JSON.stringify(x) + "\n"}
                                                                                        {/each}
                                                                                    </pre>
                                                                                {:else if text_upload}
                                                                                    {#if tdf}
                                                                                        <h5>Original, first 10 lines</h5>
                                                                                        <pre>{text_upload.split("\n").slice(0,9).join("\n")}</pre>
                                                                                    {:else if jsonn}
                                                                                        <h5>Original, first 1000 characters</h5>
                                                                                        <pre>{text_upload.substr(0,999)}</pre>
                                                                                    {/if}
                                                                                {/if}
                                                                                <!-- <Dialog.Footer>
                                                                                    <Button variant="secondary" onclick={() => reassign(v.id, vv.id)}>Reassign</Button>
                                                                                </Dialog.Footer> -->
                                                                            </Dialog.Content>
                                                                        </Dialog.Root>
                                                                        <Dialog.Root>
                                                                            <Dialog.Trigger class={buttonVariants({ variant: "secondary" })}>Bulk Reassign</Dialog.Trigger>
                                                                            <Dialog.Content>
                                                                                <Dialog.Header>
                                                                                    <Dialog.Title>Bulk Reassign</Dialog.Title>
                                                                                    <Dialog.Description>
                                                                                        Reassign all matched kits in table below
                                                                                    </Dialog.Description>
                                                                                </Dialog.Header>
                                                                                <div>
                                                                                    <label>
                                                                                        User
                                                                                        <select bind:value={new_user}>
                                                                                            <option value={null}>don't change</option>
                                                                                            <option value={emptyv}>none</option>
                                                                                            {#each vv.members as x}
                                                                                                <option value={x}>{x.name}</option>
                                                                                            {/each}
                                                                                        </select>
                                                                                    </label>
                                                                                    <label>
                                                                                        State
                                                                                        <select bind:value={new_state}>
                                                                                            <option value={null}>don't change</option>
                                                                                            {#each states as x}
                                                                                                <option value={x}>{x}</option>
                                                                                            {/each}
                                                                                        </select>
                                                                                    </label>
                                                                                </div>
                                                                                <Dialog.Footer>
                                                                                    <Button variant="secondary" onclick={() => reassign(v.id, vv.id)}>Reassign</Button>
                                                                                </Dialog.Footer>
                                                                            </Dialog.Content>
                                                                        </Dialog.Root>
                                                                    {:else}
                                                                        <div>My Kits</div>
                                                                    {/if}
                                                                    {#if models.kit.id}
                                                                        <div>
                                                                            <button class="{btn}" onclick={open_kit}>Open</button>
                                                                        </div>
                                                            <!--                {#if task_admin}
                                                                            <Modal {...deletem}>
                                                                                <div slot=summary>
                                                                                    Delete
                                                                                </div>
                                                                                <div slot=body>
                                                                                    This will delete the task {kit_index[task_id].name}, are you sure you want to do this?
                                                                                </div>
                                                                            </Modal>
                                                                        {/if} -->
                                                                    {/if}
                                                                    {#if vv.task_admin_bool}
                                                                        <!-- <DownloadTranscripts task_id={vv.id} /> -->
                                                                        <Dialog.Root>
                                                                            <Dialog.Trigger class={buttonVariants({ variant: "secondary" })}>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                                                    <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                                                                                </svg>
                                                                            </Dialog.Trigger>
                                                                            <Dialog.Content>
                                                                                <Dialog.Header>
                                                                                    <Dialog.Title>Download Transcript</Dialog.Title>
                                                                                    <Dialog.Description>
                                                                                        Download one or more transcripts, with variable columns.
                                                                                    </Dialog.Description>
                                                                                </Dialog.Header>
                                                                                <div class="overflow-auto">
                                                                                    <div class="Box-body overflow-auto">
                                                                                        <div>
                                                                                            {#await downloadp}
                                                                                                <div class="mx-auto w-8 h-8"><Spinner /></div>
                                                                                            {:then v}
                                                                                                {JSON.stringify(v)}
                                                                                            {/await}
                                                                                            <div class="form-group">
                                                                                                <div class="form-group-header">Filename (.tsv will be appended)</div>
                                                                                                <div class="form-group-body">
                                                                                                    <input
                                                                                                        type=text
                                                                                                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-md border-gray-300"
                                                                                                        bind:value={filename}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="form-group">
                                                                                                <div class="form-group-header">
                                                                                                    <label>
                                                                                                        <input
                                                                                                            type=checkbox
                                                                                                            class="focus:ring-indigo-500 focus:border-indigo-500 h-4 w-4 border-gray-300"
                                                                                                            bind:checked={include_headers}
                                                                                                        />
                                                                                                        Include Headers
                                                                                                    </label>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="form-group">
                                                                                                <div class="form-group-header">
                                                                                                    <label>
                                                                                                        <input
                                                                                                            type=checkbox
                                                                                                            class="focus:ring-indigo-500 focus:border-indigo-500 h-4 w-4 border-gray-300"
                                                                                                            bind:checked={include_speaker}
                                                                                                        />
                                                                                                        Include Speaker
                                                                                                    </label>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div class="form-group">
                                                                                                <div class="form-group-header">
                                                                                                    <label>
                                                                                                        <input
                                                                                                            type=checkbox
                                                                                                            class="focus:ring-indigo-500 focus:border-indigo-500 h-4 w-4 border-gray-300"
                                                                                                            bind:checked={include_section}
                                                                                                        />
                                                                                                        Include Section
                                                                                                    </label>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <!-- {#if json}
                                                                                            <button class="{btn}" on:click={add} data-close-dialog>add</button>
                                                                                        {:else if text}
                                                                                            <button class="{btn}" on:click={download}>download</button>
                                                                                        {/if} -->
                                                                                        <div><button class="{btn}" onclick={() => create_download(vv.id)}>Create</button> a transcript file, which you can preview below
                                                                                            {#if url}
                                                                                                <!-- svelte-ignore a11y_missing_attribute -->
                                                                                                and then <a bind:this={link} download={filename}>Download</a>
                                                                                            {/if}
                                                                                            {#if json_download}
                                                                                                {#each json_download as x}
                                                                                                    {JSON.stringify(x) + "\n"}
                                                                                                {/each}
                                                                                            {:else if textt}
                                                                                                <h4>Preview</h4>
                                                                                                <pre>{textt}</pre>
                                                                                            {/if}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <!-- <Dialog.Footer>
                                                                                    <Button variant="secondary" onclick={() => reassign(v.id, vv.id)}>Save</Button>
                                                                                </Dialog.Footer> -->
                                                                            </Dialog.Content>
                                                                        </Dialog.Root>
                                                            <!--                 <Modal {...createm}>
                                                                            <div slot=summary>
                                                                                Create Task
                                                                            </div>
                                                                            <div slot=body>
                                                                                <form>
                                                                                    <label>
                                                                                        Name
                                                                                        <input type=text bind:value={name}/>
                                                                                    </label>
                                                                                </form>
                                                                            </div>
                                                                            <div slot=footer>
                                                                                <button type="button" class="{btn}"   data-close-dialog on:click={create}>Create</button>
                                                                            </div>
                                                                        </Modal> -->
                                                                    {/if}
                                                                </div>
                                                                <hr>
                                                                <Help {help}>
                                                                    {#snippet content()}
                                                                        <div>
                                                                            <p>The table can be filtered by user, state, and text (which matches any column)</p>
                                                                            <p>The filters are conjoined (all must be true)</p>
                                                                            <p>The Bulk Reassign feature depends on these filters; the filters select the kits to be reassigned</p>
                                                                        </div>
                                                                    {/snippet}
                                                                </Help>
                                                                {#if rows}
                                                                    <Table
                                                                        bind:this={kits_for_task_table}
                                                                        indexf={x => models.kit.index = x}
                                                                        columns={[
                                                                            [ 'ID', 'id', 'col-1' ],
                                                                            [ 'UID', 'uid', 'col-1', 'f', (x, y) => window.open(x.link) ],
                                                                            [ 'State', 'state', 'col-1', 'filter' ],
                                                                            [ 'Source', 'source_uid', 'col-1' ],
                                                                            [ 'Continue', 'continue', 'col-1', 'html' ],
                                                                            [ 'User', 'user', 'col-1', 'filter' ],
                                                                            [ 'Broken Comment', 'broken_comment', 'col-1' ],
                                                                            [ 'Updated At', 'updated_at', 'col-1' ]
                                                                        ]}
                                                                        {rows}
                                                                        selectedf={(x, y) => (models.kit.id = x) && set_style(y)}
                                                                    />
                                                                {/if}
                                                            {/if}
                                                        {/await}
                                                    {/if}
                                                </Tabs.Content>
                                                <Tabs.Content value="done">
                                                    {#if models.task.tab == 'done'}
                                                        <!-- <DoneKits
                                                            {help}
                                                            project_id={v.id}
                                                            task_id={vv.id}
                                                            task_admin={vv.task_admin_bool}
                                                            task_users={vv.members}
                                                        /> -->
                                                        {#await donekitsp}
                                                            <div class="mx-auto w-8 h-8"><Spinner /></div>
                                                        {:then rows}
                                                            <div class="flex justify-around mb-4">
                                                                {#if vv.task_admin_bool}
                                                                    <div>All Done Kits</div>
                                                                    <!-- dialogs -->
                                                                {:else}
                                                                    <div>My Done Kits</div>
                                                                {/if}
                                                            </div>
                                                            <hr>
                                                            {#if rows}
                                                                <Table
                                                                    bind:this={donekits_for_task_table}
                                                                    indexf={x => models.donekit.index = x}
                                                                    columns={[
                                                                        [ 'ID', 'id', 'col-1' ],
                                                                        [ 'UID', 'uid', 'col-1', 'f', (x, y) => window.open(x.link) ],
                                                                        [ 'Source', 'source_uid', 'col-1' ],
                                                                        [ 'User', 'user', 'col-1', 'filter' ],
                                                                        [ 'Done Comment', 'done_comment', 'col-1' ],
                                                                    ]}
                                                                    {rows}
                                                                    selectedf={(x, y) => (models.donekit.id = x) && set_style(y)}
                                                                />
                                                            {/if}
                                                        {/await}
                                                    {/if}
                                                </Tabs.Content>
                                                <Tabs.Content value="duals">
                                                    {#if tab == 'duals'}duals
                                                <!-- <Duals
                                                    {help}
                                                    {project_id}
                                                    {task_id}
                                                    task_admin={task_admin_boovv.l}
                                                    {task_users}
                                                    {meta}
                                                /> -->
                                                    {/if}
                                                </Tabs.Content>
                                                <Tabs.Content value="members">
                                                    {@render member_tab('task', vv)}
                                                </Tabs.Content>
                                                <Tabs.Content value="batches">
                                                    {#if tab == 'batches'}batches
                                                <!-- {#if project_admin || lead_annotator || task_admin_bool}
                                                    <KitBatches
                                                        {help}
                                                        {project_id}
                                                        {task_id}
                                                        task_admin={task_admin_bool}
                                                        {task_users}
                                                    />
                                                {:else}
                                                    Permission Denied
                                                {/if} -->
                                                    {/if}
                                                </Tabs.Content>
                                                <Tabs.Content value="nodes">
                                                    {#if tab == 'nodes'}nodes
                                                <!-- {#if project_admin || lead_annotator || task_admin_bool}
                                                    <Nodes
                                                        {project_id}
                                                        {task_id}
                                                    />
                                                {:else}
                                                    Permission Denied
                                                {/if} -->
                                                    {/if}
                                                </Tabs.Content>
                                                <Tabs.Content value="nb">
                                                    {#if tab == 'nb'}nb
                                                <!-- {#if project_admin || lead_annotator || task_admin_bool}
                                                    <NewBatches
                                                        {help}
                                                        {task_id}
                                                        task_admin={task_admin_bool}
                                                        {task_users}
                                                    />
                                                {:else}
                                                    Permission Denied
                                                {/if} -->
                                                    {/if}
                                                </Tabs.Content>
                                            </Tabs.Root>
                                        {/if}
                                    {/await}
                                {:else}
                                    <div class="flex justify-around items-center my-2">
                                        {#if v.project_admin_bool}
                                            <div class="font-semibold">All Tasks</div>
                                        {:else}
                                            <div class="font-semibold">My Tasks</div>
                                        {/if}
                                        {#if models.task.id && models.task.index}
                                            <div>
                                                <button class={buttonVariants({ variant: "secondary" })} onclick={() => actions.task.get_one()}>Open</button>
                                            </div>
                                            {@render boiler7('task')}
                                            {#if v.project_admin_bool}
                                                {@render dialog_delete('task')}
                                            {/if}
                                        {/if}
                                        {#if v.project_admin_bool}
                                            {@render dialog_create('task')}
                                        {/if}
                                    </div>
                                    <Table
                                        indexf={x => models.task.index = x}
                                        columns={[
                                            [ 'ID', 'id', 'col-1' ],
                                            [ 'Task', 'name', 'col-2' ],
                                            [ 'Available Kits', 'available_kit_count', 'col-1' ],
                                            [ 'Source UID', 'source_uid', 'col-1' ]
                                        ]}
                                        rows={v.tasks}
                                        selectedf={(x, y) => (models.task.id = x) && set_style(y)}
                                    />
                                {/if}
                            </Tabs.Content>
                            <Tabs.Content value="members">
                                {@render member_tab('project', v)}
                            </Tabs.Content>
                        </Tabs.Root>
                    {/await}
                {:else}
                    {@render boiler3("project", admin, lead_annotator)}
                    <Table
                        indexf={x => models.project.index = x}
                        columns={[
                            [ 'ID', 'id', 'col-1' ],
                            [ 'Project', 'name', 'col-2', 'html' ],
                            [ 'Task Count', 'task_count', 'col-1' ]
                        ]}
                        rows={v}
                        selectedf={(x, y) => (models.project.id = x) && set_style(y)}
                    />
                {/if}
            {/await}
        {/if}
    </Tabs.Content>
    <Tabs.Content value="browse">
        {#if tab == 'browse'}
    <Browse
        {help}
        {admin}
        {portal_manager}
        {project_manager}
        {p}
        bind:this={browsex}
    />
        {/if}
    </Tabs.Content>
    <Tabs.Content value="kit_types">
        <Help {help}>
            {#snippet content()}
                <div>
                    <p>kit types</p>
                </div>
            {/snippet}
        </Help>
        {#if tab == 'kit_types'}
            {#await tabp}
                <div class="mx-auto w-8 h-8"><Spinner /></div>
            {:then v}
                {#if pp}
                    {@render boiler1('kit_type')}
                {:else}
                    {@render boiler3('kit_type', admin, lead_annotator)}
                    <Table
                        indexf={x => models.kit_type.index = x}
                        columns={[
                            [ 'ID', 'id', 'col-1' ],
                            [ 'Name', 'name', 'col-2' ]
                        ]}
                        rows={v}
                        selectedf={(x, y) => (models.kit_type.id = x) && set_style(y)}
                    />
                {/if}
            {/await}
        {/if}
    </Tabs.Content>
    <Tabs.Content value="features">
        {#if tab == 'features'}
            <Help {help}>
                {#snippet content()}
                <div>
                    <p>features</p>
                </div>
                {/snippet}
            </Help>
            {#await tabp}
                <div class="mx-auto w-8 h-8"><Spinner /></div>
            {:then v}
                {#if pp}
                    {@render boiler1('feature')}
                {:else}
                    {@render boiler3("feature", admin, lead_annotator)}
                    <Table
                        indexf={x => models.feature.index = x}
                        columns={[
                            [ 'Category', 'category', 'col-1' ],
                            [ 'Feature', 'name', 'col-1' ],
                            [ 'Value', 'value', 'col-1' ],
                            [ 'Label', 'label', 'col-2' ],
                            [ 'Description', 'description', 'col-8' ]
                        ]}
                        rows={v}
                        selectedf={(x, y) => (models.feature.id = x) && set_style(y)}
                    />
                {/if}
            {/await}
        {/if}
    </Tabs.Content>
    <Tabs.Content value="workflows">
        {#if tab == 'workflows'}
            <Help {help}>
                {#snippet content()}
                <div>
                    <p>workflows</p>
                </div>
                {/snippet}
            </Help>
            {#await tabp}
                <div class="mx-auto w-8 h-8"><Spinner /></div>
            {:then v}
                {#if pp}
                    {@render boiler1('workflow')}
                {:else}
                    {@render boiler3("workflow", admin, lead_annotator)}
                    <Table
                        indexf={x => models.workflow.index = x}
                        columns={[
                            [ 'Name', 'name', 'col-1' ],
                            [ 'Description', 'description', 'col-1' ],
                            [ 'Type', 'type', 'col-1' ]
                        ]}
                        rows={v}
                        selectedf={(x, y) => (models.workflow.id = x) && set_style(y)}
                    />
                {/if}
            {/await}
        {/if}
    </Tabs.Content>
    <Tabs.Content value="groups">
        {#if tab == 'groups'}
            <Help {help}>
                {#snippet content()}
                <div>
                    <p>groups</p>
                </div>
                {/snippet}
            </Help>
            {#await tabp}
                <div class="mx-auto w-8 h-8"><Spinner /></div>
            {:then v}
                {#if pp}
                    {@render boiler2('group')}
                    {#await pp}
                        <div class="mx-auto w-8 h-8"><Spinner /></div>
                    {:then v}
                        {@render boiler4(v)}
                        <Tabs.Root bind:value={models.group.tab} class="w-full">
                            <Tabs.List>
                                <Tabs.Trigger value="info">Group Info</Tabs.Trigger>
                                <Tabs.Trigger value="members">Group Members</Tabs.Trigger>
                            </Tabs.List>
                            <Tabs.Content value="info">
                                {@render boiler5('group', v)}
                             </Tabs.Content>
                            <Tabs.Content value="members">
                                {@render member_tab('group', v)}
                            </Tabs.Content>
                        </Tabs.Root>
                    {/await}
                {:else}
                    {@render boiler3("group", admin, lead_annotator)}
                    <Table
                        indexf={x => models.group.index = x}
                        columns={[
                            [ 'Name', 'name', 'col-1' ],
                            [ 'Description', 'description', 'col-1' ],
                            [ 'Type', 'type', 'col-1' ],
                        ]}
                        rows={v}
                        selectedf={(x, y) => (models.group.id = x) && set_style(y)}
                    />
                {/if}
            {/await}
        {/if}
    </Tabs.Content>
    <Tabs.Content value="invites">
        {#if tab == 'invites'}
            {#if project_manager}
                <div class="flex justify-around">
                    <div>
                        Invitations you made
                    </div>
                    <!-- <Modal {...h}>
                        {#snippet summary()}
                        <div>
                            Send Invitation
                        </div>
                        {/snippet}
                        {#snippet body()}
                        <div>
                            <form onsubmit={preventDefault(()=>null)}>
                                <div>
                                    <label>Email
                                        <input type=text bind:value={email}/>
                                    </label>
                                </div>
                                {#if admin || portal_manager}
                                    <div class="pt-2">
                                        Optionally, give the person a special role.
                                    </div>
                                {/if}
                                {#if admin}
                                    <div>
                                        <label>
                                        <input type=radio bind:group={role} value={"Project Manager"}>
                                        Project Manager
                                        </label> 
                                    </div>
                                {/if}
                                {#if portal_manager}
                                    <div>
                                        <label>
                                        <input type=radio bind:group={role} value={"Portal Manager"}>
                                        Portal Manager
                                        </label> 
                                    </div>
                                {/if}
                                {#if project_manager}
                                    <div class="pt-2">
                                        <div>If you want to automatically add the invitee to</div>
                                        <div>a project and/or task, select those here.</div>
                                    </div>
                                    {#await p}
                                    <div class="mx-auto w-8 h-8"><Spinner /></div>
                                    {:then v}
                                        <div>
                                            <label for=x>Project</label>
                                            <select id=x class="form-select" bind:value={project_id}>
                                                <option value={null}></option>
                                                {#each v.projects as project}
                                                    <option value={project.id}>
                                                        {project.name}
                                                    </option>
                                                {/each}
                                            </select>
                                        </div>
                                        <div>
                                            {#if project_id && project_id != v.personal}
                                                <label for=y>Task</label>
                                                <select id=y class="form-select" bind:value={task_id}>
                                                    <option value={null}></option>
                                                    {#each v.tasks_index[project_id] as task}
                                                        <option value={task.id}>
                                                            {task.name}
                                                        </option>
                                                    {/each}
                                                </select>
                                            {/if}
                                        </div>
                                    {/await}
                                {/if}
                            </form>
                        </div>
                        {/snippet} -->
                        <!-- <div slot=footer>
                            <button type="button" class="{btn}"   data-close-dialog on:click={create_invite}>Send</button>
                        </div> -->
                </div>
                {#await tabp}
                    <div class="mx-auto w-8 h-8"><Spinner /></div>
                {:then v}
                    <!-- <Table {columns} rows={v.users} use_filter={true} key_column=email height=500 /> -->
                    <Table
                        indexf={x => models.invite.index = x}
                        columns={[
                            [ 'Email', 'email', 'col-1' ],
                            [ 'Sent', 'sent', 'col-1' ],
                            [ 'Activated', 'activated', 'col-1' ]
                        ]}
                        rows={v.users}
                        selectedf={(x, y) => (models.invite.id = x) && set_style(y)}
                    />
                {/await}
            {:else}
                Not allowed
            {/if}
        {/if}
    </Tabs.Content>
    <Tabs.Content value="permissions">
        {#if tab == 'permissions'}
    <div class="col-2 mx-auto">
        {#if admin}
            <div>You're an Admin.</div>
            <div><button class="{btn}" onclick={ () => { admin = false; portal_manager = true } }>Set yourself to Portal Manager</button></div>
        {:else if portal_manager}
            <div>You're a Portal Manager.</div>
            <div><button class="{btn}" onclick={ () => { portal_manager = false; project_manager = true; lead_annotator = true } }>Set yourself to Project Manager</button></div>
        {:else if project_manager}
            <div>You're a Project Manager.</div>
            <div><button class="{btn}" onclick={ () => { project_manager = false; lead_annotator = false } }>Set yourself to normal User</button></div>
        {:else}
            You don't have any global permissions.
        {/if}
    </div>
        {/if}
    </Tabs.Content>
    <Tabs.Content value="pictures">
        {#if tab == 'pictures' && project_manager}
            <Help {help}>
                pics
            </Help>
            <UploadFile onUpload={upload3} onDone={done} />
            <hr>
            {#if selectedfkey}
                <div class="xmx-auto xw-1/2 text-center">Selected File: {selectedfkey}, Original Name: {selectedforiginal}</div>
            {/if}
            {#key picsp}
                {#await picsp}
                    <div class="mx-auto w-8 h-8"><Spinner /></div>
                {:then v}
                    <Table
                        indexf={x => null}
                        columns={[
                            [ 'Key', 'Key', 'col-2' ],
                            [ 'LastModified', 'LastModified', 'col-2' ],
                            [ 'Size', 'Size', 'col-1' ]
                        ]}
                        rows={v}
                        key_column="Key"
                        selectedf={selectedfupload}
                    />
                {/await}
            {/key}
        {/if}
    </Tabs.Content>
    <Tabs.Content value="responses">
        {#if tab == 'responses' && project_manager}
            <Help {help}>
                responses
            </Help>
            {#if selectedfkeyresponse}
                <div class="mx-auto w-96">
                    <div class="xmx-auto xw-1/2 text-center">Selected File: {selectedfkeyresponse}, Original Name: </div>
                    {@render audioLoader(`vital/collection/${selectedfkeyresponse}.wav`)}
                    {#if transcriptp}
                        {#await transcriptp}
                            searching...
                        {:then v}
                            {#if v.transcript}
                                {JSON.stringify(v.transcript.map( x => x.text ).join(' '))}
                            {:else}
                                <!-- {#if waiting_on_rev == 1}
                                    <div>waiting on rev...</div>
                                {:else if waiting_on_rev == 2}
                                    <div>rev returned transcript, refreshing...</div>
                                {:else} -->
                                    <div>transcript not found</div>
                                    <!-- <div><button class="{btn}" onclick={send_to_rev}>send to rev</button></div>
                                {/if} -->
                            {/if}
                        {/await}
                    {:else}
                        <div><button class="{btn}" onclick={check_transcript}>check in db</button></div>
                    {/if}
                </div>
            {/if}
            {#key responsesp}
                {#await responsesp}
                    <div class="mx-auto w-8 h-8"><Spinner /></div>
                {:then v}
                    <div class="mb-2">
                        <button class="{btn}" onclick={() => download_responses(mod_rows(v))}>Download TSV</button>
                    </div>
                    <Table
                        indexf={x => null}
                        columns={[
                            [ 'ID', 'id', 'col-1' ],
                            [ 'User', 'user_id', 'col-1' ],
                            [ 'Session', 'session_combined', 'col-1' ],
                            [ 'Kit', 'kit_uid_short', 'col-1' ],
                            [ 'Picture', 'picture', 'col-1' ],
                            [ 'Response1', 'response1_short', 'col-1', 'f', (x, y) => click_response(x, y) ],
                            [ 'Response2', 'response2_short', 'col-1', 'f', (x, y) => click_response(x, y) ],
                            [ 'Response3', 'response3_short', 'col-1', 'f', (x, y) => click_response(x, y) ],
                            [ 'Response4', 'response4', 'col-1' ],
                            [ 'Modified', 'updated_at', 'col-1' ],
                            [ 'By Pass', 'bypass', 'col-1', 'f', (x, y) => click_bypass(x, y) ]
                        ]}
                        rows={mod_rows(v)}
                        key_column="id"
                        selectedf={selectedfresponse}
                        height="96"
                    />
                {/await}
            {/key}
        {/if}
    </Tabs.Content>
    <Tabs.Content value="skip">
        {#if tab == 'skip' && project_manager}
            <Help {help}>
                skip
            </Help>
            {#if selectedSkipRow && skippable_user(selectedSkipRow.user_id)}
                <div class="mb-2">
                    <label class="mr-2">
                        Sessions to advance
                        <input type="number" min="1" class="w-16 border rounded px-1" bind:value={skipCount} />
                    </label>
                    <button class="{btn}" onclick={skip_session}>Skip</button>
                    {#if skipResult}
                        <pre class="mt-2 p-2 bg-gray-100 text-xs whitespace-pre-wrap">{skipResult}</pre>
                    {/if}
                </div>
            {:else if selectedSkipRow}
                <div class="mb-2 text-sm">
                    No Skip button: user "{selectedSkipRow.user_id}" isn't a VITAL or HC user
                    (only VITAL followed by three digits, e.g. VITAL012, or a 24 character
                    Prolific ID can be skipped).
                </div>
            {:else}
                <div class="mb-2 text-sm">
                    Select a row below to show the Skip button. The row should be the
                    user's latest session.
                </div>
            {/if}
            {#key responsesp}
                {#await responsesp}
                    <div class="mx-auto w-8 h-8"><Spinner /></div>
                {:then v}
                    <Table
                        indexf={x => skipIndex = x}
                        columns={[
                            [ 'ID', 'id', 'col-1' ],
                            [ 'User', 'user_id', 'col-1' ],
                            [ 'Session', 'session_combined', 'col-1' ],
                            [ 'Kit', 'kit_uid_short', 'col-1' ],
                            [ 'Picture', 'picture', 'col-1' ],
                            [ 'Modified', 'updated_at', 'col-1' ]
                        ]}
                        rows={mod_rows(v)}
                        key_column="id"
                        selectedf={selectedfskip}
                        height="96"
                    />
                {:catch e}
                    <div class="text-sm">
                        No Skip button: the responses table failed to load ({e?.message || e}).
                    </div>
                {/await}
            {/key}
        {:else if tab == 'skip'}
            <div class="text-sm">
                No Skip button: skipping sessions is only available to project managers.
            </div>
        {/if}
    </Tabs.Content>
    <Tabs.Content value="archive">
        {#if tab == 'archive' && admin}
            <Help {help}>
                Archiving a response set copies its row into the archive table and
                deletes it from the response table, so it no longer shows on the
                Responses or Skip tabs.  This list shows both, by original ID.
                There is no unarchive.
            </Help>
            {#if archiveConfirm}
                <div class="mb-2 p-2 border rounded bg-yellow-50">
                    Archive response set {archiveConfirm.id}
                    (user {archiveConfirm.user_id}, session {archiveConfirm.session_combined})?
                    This can't be undone.
                    <button class="{btn}" onclick={archive_response_set}>Archive</button>
                    <button class="{btn}" onclick={() => archiveConfirm = null}>Cancel</button>
                </div>
            {/if}
            {#if archiveResult}
                <pre class="mb-2 p-2 bg-gray-100 text-xs whitespace-pre-wrap">{archiveResult}</pre>
            {/if}
            {#key archivesp}
                {#await archivesp}
                    <div class="mx-auto w-8 h-8"><Spinner /></div>
                {:then v}
                    <Table
                        indexf={x => null}
                        columns={[
                            [ 'ID', 'id', 'col-1' ],
                            [ 'User', 'user_id', 'col-1' ],
                            [ 'Session', 'session_combined', 'col-1' ],
                            [ 'Kit', 'kit_uid_short', 'col-1' ],
                            [ 'Picture', 'picture', 'col-1' ],
                            [ 'Modified', 'updated_at', 'col-1' ],
                            [ 'Archived', 'archived_text', 'col-1', 'filter' ],
                            [ '', 'archive_button', 'col-1', 'fbutton', (x) => { archiveConfirm = x; archiveResult = null; } ]
                        ]}
                        rows={v || []}
                        key_column="id"
                        selectedf={() => null}
                        height="96"
                    />
                {:catch e}
                    <div class="text-sm">The response sets failed to load ({e?.message || e}).</div>
                {/await}
            {/key}
        {:else if tab == 'archive'}
            <div class="text-sm">Archiving response sets is only available to admins.</div>
        {/if}
    </Tabs.Content>
    <Tabs.Content value="passes">
        {#if tab == 'passes' && project_manager}
            <Help {help}>
                passes
            </Help>
            {#key passesp}
                {#await passesp}
                    <div class="mx-auto w-8 h-8"><Spinner /></div>
                {:then v}
                    <Table
                        indexf={x => null}
                        columns={[
                            [ 'ID', 'id', 'col-1' ],
                            [ 'User', 'user_id', 'col-1' ],
                            [ 'Session', 'session_id', 'col-1' ],
                            [ 'By Pass', 'ok', 'col-1' ],
                            [ 'Created', 'created_at', 'col-1' ]
                        ]}
                        rows={v}
                        key_column="id"
                        selectedf={selectedfpass}
                        height="96"
                    />
                {/await}
            {/key}
        {/if}
    </Tabs.Content>
    <Tabs.Content value="events">
        {#if tab == 'events' && project_manager}
            <Help {help}>
                Every step of a recording session leaves an event here: the row being
                bound to a kit, the picture code being resolved, each recording being
                named, and each upload starting, succeeding or failing.  A recording in
                S3 with no filename in the response table, or a filename with no audio,
                should be explained by the events for its kit.
            </Help>
            <div class="mb-2 flex gap-2 items-center">
                <input
                    class="focus:ring-indigo-500 focus:border-indigo-500 rounded-md border-gray-300 border-2 p-1"
                    bind:value={events_kit_uid}
                    placeholder="kit uid (blank for all)"
                >
                <button class="{btn}" onclick={get_events}>Reload</button>
                {#if eventsp}
                    {#await eventsp then v}
                        <button class="{btn}" onclick={() => download_events(v)}>Download TSV</button>
                    {/await}
                {/if}
            </div>
            {#key eventsp}
                {#await eventsp}
                    <div class="mx-auto w-8 h-8"><Spinner /></div>
                {:then v}
                    <Table
                        indexf={x => null}
                        columns={[
                            [ 'ID', 'id', 'col-1' ],
                            [ 'Time', 'created_at', 'col-1' ],
                            [ 'User', 'user_id', 'col-1' ],
                            [ 'Kit', 'kit_uid', 'col-1' ],
                            [ 'Session', 'session', 'col-1' ],
                            [ 'Src', 'source', 'col-1', 'filter' ],
                            [ 'Category', 'category', 'col-1', 'filter' ],
                            [ 'Event', 'name', 'col-1', 'filter' ],
                            [ 'Ok', 'ok', 'col-1' ],
                            [ 'File', 'filename', 'col-1' ],
                            [ 'Seq', 'seq', 'col-1' ],
                            [ 'Detail', 'detail', 'col-3' ]
                        ]}
                        rows={v || []}
                        key_column="id"
                        selectedf={() => null}
                        height="96"
                    />
                {/await}
            {/key}
        {/if}
    </Tabs.Content>
    <Tabs.Content value="releases">
        {#if tab == 'releases'}
            <Releases {admin} {project_manager} />
        {/if}
    </Tabs.Content>
</Tabs.Root>

